import React, { useCallback, useEffect } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'

import { intl, IntlInterface, wizard, WizardInterface } from '../../hoc'
import { contractActions, modalDialogActions } from '../../redux'
import messages from '../../i18n'
import { CONTRACT_SPINNER_DELAY } from '../../constants/commonConstants'
import styles from './../../constants/styles.scss'
import { PrintLoader } from '../../components/PrintLoader/PrintLoader'
import { ErrSuccess } from '../../types/form'
import { Response } from '../../api/api'
import { API_ERROR } from '../../constants/modals'

interface DispatchProps {
  fetchContract: (callbacks: ErrSuccess) => void
  showModalDialog: Function
}

interface Props extends IntlInterface, WizardInterface, DispatchProps {}

export const PrintContract: React.FC<Props> = ({
  fetchContract,
  showModalDialog,
  translate,
  translateHTML,
  wizard,
}: Props) => {
  const init = useCallback(() => {
    const onInitError = (errorType: Response) => {
      showModalDialog(
        API_ERROR({
          errorInfo: { type: errorType },
          onRetry: init,
        })
      )
    }

    const onInitSuccess = () => {
      setTimeout(wizard.gotoNext, CONTRACT_SPINNER_DELAY)
    }

    fetchContract({ success: onInitSuccess, error: onInitError })
  }, [fetchContract, showModalDialog, wizard.gotoNext])

  useEffect(() => {
    init()
  }, [init])

  return (
    <PrintLoader
      subtitle={translate(messages.printContract.subTitle)}
      warning={translate(messages.printContract.warning)}>
      {translate(messages.printContract.titleA)}
      <span className={styles.infoText}>{translate(messages.printContract.titleB)}</span>
      {translateHTML(messages.printContract.titleC)}
    </PrintLoader>
  )
}

const mapDispatchToProps: DispatchProps = {
  fetchContract: contractActions.fetchContract,
  showModalDialog: modalDialogActions.showModalDialog,
}

const enhance = compose(intl, wizard, connect(null, mapDispatchToProps))

export default enhance(PrintContract)
